import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,426.666667 C665.866667,426.666667 426.666667,666 426.666667,960 C426.666667,1254.13333 665.866667,1493.33333 960,1493.33333 C1254.13333,1493.33333 1493.33333,1254.13333 1493.33333,960 C1493.33333,666 1254.13333,426.666667 960,426.666667 M960,1706.66667 C548.266667,1706.66667 213.333333,1371.73333 213.333333,960 C213.333333,548.373333 548.266667,213.333333 960,213.333333 C1371.73333,213.333333 1706.66667,548.373333 1706.66667,960 C1706.66667,1371.73333 1371.73333,1706.66667 960,1706.66667 M960,0 C430.72,0 0,430.72 0,960 C0,1489.38667 430.72,1920 960,1920 C1489.28,1920 1920,1489.38667 1920,960 C1920,430.72 1489.28,0 960,0",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconRecordSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconRecordSolid, _Component);

  var _super = _createSuper(IconRecordSolid);

  function IconRecordSolid() {
    _classCallCheck(this, IconRecordSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconRecordSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRecord",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconRecordSolid.displayName = "IconRecordSolid";
  return IconRecordSolid;
}(Component);

IconRecordSolid.glyphName = 'record';
IconRecordSolid.variant = 'Solid';
IconRecordSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRecordSolid;
export { IconRecordSolid };